/* ============================================================
   LORENTIS — Cinematic Animation Engine (vanilla, GPU-friendly)
   ============================================================ */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 1025;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lerp = function (a, b, n) { return (1 - n) * a + n * b; };
  var clamp = function (v, mn, mx) { return Math.max(mn, Math.min(mx, v)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    var fmt = (window.LORENTIS && window.LORENTIS.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }
  window.LORENTIS = window.LORENTIS || {};
  window.LORENTIS.formatMoney = formatMoney;

  /* ---------- Loader ---------- */
  function loader() {
    var el = $('.loader');
    if (!el) { document.documentElement.classList.remove('loading'); return; }
    document.documentElement.classList.add('loading');
    var logo = $('.loader__logo'), bar = $('.loader__bar i'), pct = $('.loader__pct');
    var p = 0;
    if (RM) { finish(); return; }
    logo.animate([{ opacity: 0, transform: 'scale(.82)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 900, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
    var iv = setInterval(function () {
      p += Math.random() * 16 + 6; if (p >= 100) p = 100;
      bar.style.width = p + '%'; if (pct) pct.textContent = Math.round(p);
      if (p >= 100) { clearInterval(iv); setTimeout(finish, 380); }
    }, 130);
    function finish() {
      el.classList.add('is-done');
      document.documentElement.classList.remove('loading');
      document.body.classList.add('loaded');
      setTimeout(function () { el.remove(); }, 1300);
      revealHero();
    }
  }

  /* ---------- Custom cursor ---------- */
  function cursor() {
    if (isTouch || RM) return;
    var c = $('.cursor'); if (!c) return;
    document.body.classList.add('cursor-active');
    var ring = $('.cursor__ring'), dot = $('.cursor__dot');
    var mx = window.innerWidth / 2, my = window.innerHeight / 2, rx = mx, ry = my;
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    });
    (function raf() {
      rx = lerp(rx, mx, 0.18); ry = lerp(ry, my, 0.18);
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(raf);
    })();
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a,button,.pcard,.gcard,[data-cursor]')) c.classList.add('is-hover');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a,button,.pcard,.gcard,[data-cursor]')) c.classList.remove('is-hover');
    });
    document.addEventListener('mouseleave', function () { c.classList.add('is-hidden'); });
    document.addEventListener('mouseenter', function () { c.classList.remove('is-hidden'); });
  }

  /* ---------- Split text ---------- */
  function splitText() {
    $$('[data-split]').forEach(function (el) {
      if (el.dataset.done) return; el.dataset.done = '1';
      var nodes = Array.prototype.slice.call(el.childNodes);
      el.innerHTML = '';
      nodes.forEach(function (node) {
        if (node.nodeType !== 3) { el.appendChild(node); return; }
        node.textContent.split(/(\s+)/).forEach(function (w) {
          if (w.trim() === '') { el.appendChild(document.createTextNode(' ')); return; }
          var word = document.createElement('span'); word.className = 'word';
          w.split('').forEach(function (ch, i) {
            var s = document.createElement('span'); s.className = 'char';
            s.textContent = ch; s.style.transitionDelay = (i * 22) + 'ms';
            word.appendChild(s);
          });
          el.appendChild(word);
        });
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function reveal() {
    var els = $$('[data-reveal],[data-reveal-mask],[data-stagger],[data-split]');
    if (RM) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute('data-stagger')) {
          var d = parseInt(el.dataset.stagger || '90', 10);
          $$(':scope > *', el).forEach(function (child, i) { child.style.transitionDelay = (i * d) + 'ms'; });
        }
        el.classList.add('in'); io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Parallax ---------- */
  function parallax() {
    if (RM || isTouch) return;
    var items = $$('[data-parallax]');
    if (!items.length) return;
    var ticking = false;
    function upd() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.dataset.parallax) || 0.15;
        var center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-center * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- Floating elements ---------- */
  function floaters() {
    if (RM || isTouch) return;
    $$('.float').forEach(function (el, i) {
      var amp = parseFloat(el.dataset.float) || 12, dur = 4000 + i * 700;
      el.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-' + amp + 'px)' }, { transform: 'translateY(0)' }],
        { duration: dur, iterations: Infinity, easing: 'ease-in-out' });
    });
  }

  /* ---------- Hero entrance ---------- */
  function revealHero() {
    var hero = $('[data-hero]'); if (!hero) return;
    hero.classList.add('in');
    $$('[data-split]', hero).forEach(function (e) { e.classList.add('in'); });
    $$('[data-reveal]', hero).forEach(function (e, i) { e.style.transitionDelay = (300 + i * 120) + 'ms'; e.classList.add('in'); });
  }

  /* ---------- Magnetic buttons ---------- */
  function magnetic() {
    if (RM || isTouch) return;
    $$('[data-magnetic]').forEach(function (el) {
      var strength = parseFloat(el.dataset.magnetic) || 0.4;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * strength;
        var y = (e.clientY - r.top - r.height / 2) * strength;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        var span = el.querySelector('span');
        if (span) span.style.transform = 'translate(' + x * 0.3 + 'px,' + y * 0.3 + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = ''; var span = el.querySelector('span'); if (span) span.style.transform = '';
        el.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        setTimeout(function () { el.style.transition = ''; }, 600);
      });
    });
  }

  /* ---------- 3D tilt on product cards ---------- */
  function tilt() {
    if (RM || isTouch) return;
    $$('[data-tilt]').forEach(function (el) {
      var inner = el.querySelector('.pcard__media') || el;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = 'perspective(900px) rotateY(' + (px * 7).toFixed(2) + 'deg) rotateX(' + (-py * 7).toFixed(2) + 'deg) translateZ(0)';
      });
      el.addEventListener('mouseleave', function () {
        inner.style.transform = 'perspective(900px) rotateY(0) rotateX(0)';
      });
    });
  }

  /* ---------- Header scroll ---------- */
  function header() {
    var h = $('.header'); if (!h) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      h.classList.toggle('is-scrolled', y > 40);
      if (y > 400 && y > last) h.classList.add('is-hidden'); else h.classList.remove('is-hidden');
      last = y;
    }, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  function mobileMenu() {
    var burger = $('.burger'), menu = $('.mobile-menu');
    if (!burger || !menu) return;
    function toggle(open) {
      menu.classList.toggle('is-open', open);
      burger.classList.toggle('is-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    burger.addEventListener('click', function () { toggle(!menu.classList.contains('is-open')); });
    $$('.mobile-menu__nav a', menu).forEach(function (a, i) {
      a.style.transitionDelay = (0.1 + i * 0.06) + 's';
      a.addEventListener('click', function () { toggle(false); });
    });
  }

  /* ---------- Horizontal drag scroll ---------- */
  function hscroll() {
    $$('.hscroll').forEach(function (root) {
      var vp = $('.hscroll__viewport', root), prog = $('.hprogress i', root);
      if (!vp) return;
      var down = false, startX, startL, moved = false;
      vp.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startL = vp.scrollLeft; vp.classList.add('is-dragging'); });
      window.addEventListener('mouseup', function () { down = false; vp.classList.remove('is-dragging'); });
      window.addEventListener('mousemove', function (e) { if (!down) return; e.preventDefault(); var d = e.pageX - startX; if (Math.abs(d) > 4) moved = true; vp.scrollLeft = startL - d; });
      vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      vp.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { vp.scrollLeft += e.deltaY; }
      }, { passive: true });
      function upd() { if (prog) { var m = vp.scrollWidth - vp.clientWidth; prog.style.width = clamp((m ? vp.scrollLeft / m : 0), 0.06, 1) * 100 + '%'; } }
      vp.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  /* ---------- Accordion ---------- */
  function accordions() {
    $$('.acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.acc-item'), body = $('.acc-body', item);
        var open = item.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
      });
    });
  }

  /* ---------- Marquee duplication ---------- */
  function marquees() {
    $$('.marquee__track').forEach(function (t) { if (!t.dataset.dup) { t.dataset.dup = '1'; t.innerHTML += t.innerHTML; } });
  }

  /* ========================================================
     CART (Shopify AJAX)
     ======================================================== */
  var Cart = {
    open: function () { $('.cart-drawer').classList.add('is-open'); $('.drawer-overlay').classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; },
    close: function () { $('.cart-drawer').classList.remove('is-open'); $('.drawer-overlay').classList.remove('is-open'); document.documentElement.style.overflow = ''; },
    add: function (id, qty) {
      return fetch(window.LORENTIS.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { return r.json(); }).then(function (res) { Cart.refresh(); return res; });
    },
    change: function (line, qty) {
      return fetch(window.LORENTIS.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); return c; });
    },
    refresh: function () { return fetch(window.LORENTIS.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); return c; }); },
    render: function (c) {
      var count = $('.cart-count'); if (count) { count.textContent = c.item_count; count.classList.toggle('is-visible', c.item_count > 0); }
      var box = $('.cart-drawer__items'), foot = $('.cart-drawer__foot');
      if (!box) return;
      if (!c.items.length) {
        box.innerHTML = '<div class="cart-empty"><p class="h-md display">Your bag is empty</p><a href="/collections/all" class="btn btn--outline" data-magnetic><span>Shop the collection</span></a></div>';
        if (foot) foot.style.display = 'none'; return;
      }
      if (foot) foot.style.display = '';
      box.innerHTML = c.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_200x$1') : '';
        return '<div class="cart-line" style="animation-delay:' + (i * 60) + 'ms">' +
          '<div class="cart-line__img"><img src="' + img + '" alt="' + it.product_title + '" loading="lazy"></div>' +
          '<div><a class="cart-line__name" href="' + it.url + '">' + it.product_title + '</a>' +
          '<div class="cart-line__meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
          '<div class="qty" data-line="' + (i + 1) + '"><button data-act="dec" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button data-act="inc" aria-label="Increase">+</button></div>' +
          '<a class="cart-line__remove" data-remove="' + (i + 1) + '">Remove</a></div>' +
          '<div class="cart-line__price">' + formatMoney(it.final_line_price) + '</div></div>';
      }).join('');
      var sub = $('.cart-drawer__subtotal .v'); if (sub) sub.textContent = formatMoney(c.total_price);
      box.querySelectorAll('.qty').forEach(function (q) {
        var line = parseInt(q.dataset.line, 10), span = q.querySelector('span'), cur = parseInt(span.textContent, 10);
        q.querySelector('[data-act=inc]').onclick = function () { Cart.change(line, cur + 1); };
        q.querySelector('[data-act=dec]').onclick = function () { Cart.change(line, cur - 1); };
      });
      box.querySelectorAll('[data-remove]').forEach(function (b) { b.onclick = function () { Cart.change(parseInt(b.dataset.remove, 10), 0); }; });
    },
    toast: function (msg) {
      var t = $('.atc-toast'); if (!t) { t = document.createElement('div'); t.className = 'atc-toast'; document.body.appendChild(t); }
      t.textContent = msg || 'Added to bag'; t.classList.add('is-show');
      clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-show'); }, 2200);
    }
  };
  window.LORENTIS.Cart = Cart;

  function cartBindings() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.refresh().then(Cart.open); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); return; }
      var atc = e.target.closest('[data-atc]');
      if (atc) {
        e.preventDefault();
        var id = atc.dataset.atc;
        if (!id) return;
        atc.classList.add('is-loading'); var orig = atc.querySelector('span') ? atc.querySelector('span').textContent : atc.textContent;
        Cart.add(id, 1).then(function () {
          Cart.toast('Added — Create Your Legacy');
          Cart.open();
          if (atc.querySelector('span')) atc.querySelector('span').textContent = orig;
        }).catch(function () { Cart.toast('Unavailable'); });
      }
    });
    Cart.refresh();
  }

  /* ---------- Quick view ---------- */
  function quickView() {
    var overlay = $('.quick-view'); if (!overlay) return;
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-quickview]');
      if (q) {
        e.preventDefault(); e.stopPropagation();
        var handle = q.dataset.quickview;
        fetch('/products/' + handle + '?view=quickview').then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('#quickview-content');
          $('.quick-view__slot').innerHTML = content ? content.innerHTML : '<div class="modal__body"><p>Unable to load.</p></div>';
          overlay.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
          bindVariants($('.quick-view__slot'));
        });
      }
      if (e.target.closest('[data-modal-close]') || e.target === overlay) {
        overlay.classList.remove('is-open'); document.documentElement.style.overflow = '';
      }
    });
  }

  /* ---------- Variant selection (PDP + quickview) ---------- */
  function bindVariants(scope) {
    scope = scope || document;
    $$('[data-variant-form]', scope).forEach(function (form) {
      var data = JSON.parse(form.dataset.variants || '[]');
      var selected = {};
      $$('.opt-group', form).forEach(function (g) {
        var idx = g.dataset.optIndex;
        var active = g.querySelector('.opt-pill.is-active');
        if (active) selected[idx] = active.dataset.value;
        $$('.opt-pill', g).forEach(function (p) {
          p.addEventListener('click', function () {
            $$('.opt-pill', g).forEach(function (x) { x.classList.remove('is-active'); });
            p.classList.add('is-active'); selected[idx] = p.dataset.value; update();
          });
        });
      });
      function update() {
        var match = data.find(function (v) { return v.options.every(function (o, i) { return String(selected[i]) === String(o); }); });
        var btn = $('[data-atc]', form), price = $('[data-price]', form);
        if (match) {
          if (btn) {
            btn.dataset.atc = match.id;
            btn.disabled = !match.available;
            var sp = btn.querySelector('span') || btn;
            sp.textContent = match.available ? 'Add to Bag' : 'Sold Out';
          }
          if (price) price.textContent = formatMoney(match.price);
        }
      }
      update();
    });
  }

  /* ---------- PDP gallery ---------- */
  function pdpGallery() {
    $$('.pdp__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('.pdp__main img'); if (main) main.src = t.dataset.full || t.querySelector('img').src;
        $$('.pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active');
      });
    });
    var main = $('.pdp__main');
    if (main && !isTouch && !RM) {
      main.addEventListener('mousemove', function (e) {
        var img = main.querySelector('img'); var r = main.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.6)';
      });
      main.addEventListener('mouseleave', function () { main.querySelector('img').style.transform = ''; });
    }
  }

  /* ---------- Page transition on internal nav ---------- */
  function pageTransitions() {
    if (RM) return;
    var pt = $('.page-transition'); if (!pt) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.target === '_blank' || a.hasAttribute('download') || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      if (a.hasAttribute('data-no-transition') || a.closest('[data-no-transition]')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      pt.classList.add('is-active');
      setTimeout(function () { window.location.href = href; }, 520);
    });
    window.addEventListener('pageshow', function () { pt.classList.remove('is-active'); });
  }

  /* ---------- Init ---------- */
  function init() {
    splitText(); marquees();
    loader(); cursor(); reveal(); parallax(); floaters();
    magnetic(); tilt(); header(); mobileMenu(); hscroll();
    accordions(); cartBindings(); quickView(); bindVariants(document);
    pdpGallery(); pageTransitions();
    if (!$('.loader')) revealHero();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
